import React, { useState, useEffect } from 'react';
import { PrevIcon, NextIcon } from '../Icons';
import { IconButton } from '../IconButton';
import { isNullOrEmptyArray } from '../../util/arrays';
import * as Ui from './styles';

const MAX_DISPLAY_PAGES = 5; // Define o máximo de páginas a serem exibidas

export default function Paging({
  total,
  onPrevious,
  onNext,
  onSelectedPage,
  inputPage,
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (total > 0 && !selectedIndex) {
      setSelectedIndex(1);
    }
  }, [total, selectedIndex]);

  useEffect(() => {
    if (inputPage) {
      setSelectedIndex(parseInt(inputPage));
    }
  }, [inputPage]);

  function handlePrevClick() {
    if (selectedIndex > 1) {
      setSelectedIndex(selectedIndex - 1);
      if (onPrevious) onPrevious(selectedIndex - 1);
    }
  }

  function handlePageClick(index) {
    if (index !== selectedIndex) {
      setSelectedIndex(index);
      if (onSelectedPage) onSelectedPage(index);
    }
  }

  function handleNextClick() {
    if (selectedIndex < total) {
      setSelectedIndex(selectedIndex + 1);
      if (onNext) onNext(selectedIndex + 1);
    }
  }

  function renderPages() {
    const result = [];
    let startPage = 1;
    let endPage = total;

    if (total > MAX_DISPLAY_PAGES) {
      const half = Math.floor(MAX_DISPLAY_PAGES / 2);
      if (selectedIndex <= half) {
        endPage = MAX_DISPLAY_PAGES;
      } else if (selectedIndex >= total - half) {
        startPage = total - MAX_DISPLAY_PAGES + 1;
      } else {
        startPage = selectedIndex - half;
        endPage = selectedIndex + half;
      }
    }

    if (startPage > 1) {
      result.push((
        <Ui.Page
          clear
          active={selectedIndex === 1}
          key={`page-1`}
          title={`1`}
          onClick={() => handlePageClick(1)}
        />
      ));
      if (startPage > 2) {
        result.push(<Ui.Page key={'start-ellipsis'} title={'...'} clear />);
      }
    }

    for (let index = startPage; index <= endPage; index += 1) {
      result.push((
        <Ui.Page
          clear
          active={index === selectedIndex}
          key={`page-${index}`}
          title={`${index}`}
          onClick={() => handlePageClick(index)}
        />
      ));
    }

    if (endPage < total) {
      if (endPage < total - 1) {
        result.push(<Ui.Page key={'end-ellipsis'} title={'...'} clear />);
      }
      result.push((
        <Ui.Page
          clear
          active={selectedIndex === total}
          key={`page-${total}`}
          title={`${total}`}
          onClick={() => handlePageClick(total)}
        />
      ));
    }

    if (isNullOrEmptyArray(result)) {
      result.push(<Ui.Page active key={'page-fixed'} title={'...'} clear />);
    }

    return result;
  }

  return (
    <Ui.Container>
      <IconButton iconComponent={PrevIcon} iconSize={20} onClick={handlePrevClick} />
      <Ui.Pages>
        {renderPages()}
      </Ui.Pages>
      <IconButton iconComponent={NextIcon} iconSize={20} onClick={handleNextClick} />
    </Ui.Container>
  );
}

export { Paging };
